/* eslint-disable @typescript-eslint/no-var-requires */

export default function TrackerForm() {
  return <></>;
}
